import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ErrorBanner } from '../components/UIStates';

interface DashboardProps { onNavigate: (page: string) => void; }

const Dashboard: React.FC<DashboardProps> = ({ onNavigate }) => {
  const { user } = useAuth();
  const [ytStats, setYtStats] = useState({ views: 0, videos: 0 });
  const [ytError, setYtError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('yt_access_token');
    const expiry = localStorage.getItem('yt_token_expiry');
    if (!token) return;
    if (expiry && Date.now() > parseInt(expiry)) {
      setYtError('Votre connexion YouTube a expiré. Reconnectez-vous depuis la page YouTube Shorts.');
      return;
    }
    fetch('https://www.googleapis.com/youtube/v3/channels?part=statistics&mine=true', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        if (r.status === 401) throw new Error('expired');
        if (!r.ok) throw new Error('failed');
        return r.json();
      })
      .then(d => {
        const s = d.items?.[0]?.statistics;
        if (s) setYtStats({ views: parseInt(s.viewCount || '0'), videos: parseInt(s.videoCount || '0') });
      })
      .catch((e) => {
        setYtError(
          e?.message === 'expired'
            ? 'Votre connexion YouTube a expiré. Reconnectez-vous depuis la page YouTube Shorts.'
            : 'Les statistiques YouTube sont momentanément indisponibles.'
        );
      });
  }, []);

  const stats = [
    { label: 'Vues YouTube', value: ytStats.views.toLocaleString(), icon: '👁️', color: '#00F5A0' },
    { label: 'Vidéos publiées', value: ytStats.videos, icon: '🎬', color: '#8B6FFF' },
    { label: 'Langues', value: '45', icon: '🌍', color: '#FFB300' },
    { label: 'Plan', value: user?.plan || 'free', icon: '💎', color: '#FF6B6B' },
  ];

  const actions = [
    { icon: '🎬', label: 'Studio', page: 'studio' },
    { icon: '✨', label: 'Générer', page: 'generator' },
    { icon: '🎣', label: 'Hooks', page: 'hooks' },
    { icon: '🔥', label: 'Viral', page: 'viral' },
    { icon: '📅', label: 'Calendrier', page: 'calendar' },
    { icon: '🤖', label: 'Agent IA', page: 'agent' },
    { icon: '🧠', label: 'Coach', page: 'coach' },
    { icon: '📊', label: 'Analytics', page: 'analytics' },
  ];

  return (
    <div style={{ padding: 32 }}>
      <style>{`
        @media (max-width: 768px) {
          .dash-stats { grid-template-columns: 1fr 1fr !important; }
          .dash-actions { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>
      <div style={{ marginBottom: 32 }}>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#F8F7FF', marginBottom: 6 }}>Bonjour {user?.name} 👋</div>
        <div style={{ color: '#C8C8E8', fontSize: 14 }}>Voici ton activité ContenuIA</div>
      </div>
      <ErrorBanner message={ytError} onDismiss={() => setYtError('')} />

      <div className="dash-stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14, marginBottom: 32 }}>
        {stats.map((s, i) => (
          <div key={i} style={{ background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 16, padding: 20, textAlign: 'center' }}>
            <div style={{ fontSize: 22, marginBottom: 6 }}>{s.icon}</div>
            <div style={{ fontSize: 28, fontWeight: 800, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 11, color: '#6C6C8A', marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 16, fontWeight: 700, color: '#F8F7FF', marginBottom: 14 }}>Actions rapides</div>
      <div className="dash-actions" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12 }}>
        {actions.map(a => (
          <button key={a.page} onClick={() => onNavigate(a.page)} style={{ background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 14, padding: 18, cursor: 'pointer', textAlign: 'center' }}>
            <div style={{ fontSize: 26, marginBottom: 8 }}>{a.icon}</div>
            <div style={{ fontSize: 12, color: '#C8C8E8', fontWeight: 500 }}>{a.label}</div>
          </button>
        ))}
      </div>
    </div>
  );
};
export default Dashboard;
